import React from "react";
import FaqSection from "./FaqSection";
const startingWithNomadroof = [
  {
    question: "What is Nomadroof?",
    answer:
      "Nomadroof is an online platform for students, travellers, professionals, or expats looking for mid-to long-term housing oversees or in different cities of their countries.Our goal is to excel and make easier all the steps of finding and booking a place to live, all this conveniently made online without wasting time.",
  },
  {
    question: "How can i create an account?",
    answer:
      "Click on the + Sign Up tab located in the upper right side of the website. Sign up via Facebook, Gmail or create a username by providing your email address. If you choose the last option, you will be emailed a temporary password to access your new account.",
  },
  {
    question: "How do i update my profile and other settings?",
    answer:
      "To update your profile and other settings you need to log in to your account and go to your “Dashboard”.",
  },
  {
    question: "What information in my profile in public?",
    answer:
      "Only the information that you include in your profile is public. Your “Personal information” will only be visible to nomadroof.Once a booking and payment is confirmed, we will share your name, email address and phone number with the tenant.",
  },
  {
    question: "How do I change my password?",
    answer:
      "Go to your Dashboard and click on “Mi Profile” settings. Scroll down and you will be able to see the options to change your password.",
  },
];

const aboutListings = [
  {
    question: "What is the minimum duration of my stay?",
    answer:
      "The minimum duration of stay is 1 month, but you can book a property for less than that time if you agree on that wirelationsth Landlord. You will still need to pay the total amount of first month’s rent through Nomadroof.",
  },
  {
    question: "How do i apply filters to my search?",
    answer:
      "Type the city you want to move and select your check-in and check-out dates, and number of tenants that will take the property. Click on search and you will be redirected to all the listings available. Over there, you will be able to narrow down your search by applying filters such as number of rooms, bedrooms or baths, type and size of property, and price range. If you click on “More Options”, you will be able to apply the amenities you are looking on a property.",
  },
  {
    question: "Can i sechedule a physical visit to a potetial property?",
    answer:
      "Nomadroof is a fully online service, therefore it is not necessary to schedule a physical visit to a property. Most people that use Nomadroof are looking for accommodation in a different country and at our platform you will find accurate and detail information from verified listings that you can trust.",
  },
  {
    question: "How can I message Host?",
    answer: "You can only message a Host once a booking is confirmed.",
  },
  {
    question: "Where do I find my conversation with Host?",
    answer:
      "After booking is confirmed, you will be able to chat directly with Host. You can find your conversations in “My Inbox”, located in your dashboard. You will also received notifications of new messages by email.",
  },
];

const faqData = [
  {
    title: "BOOKING & PAYMENTS",
    items: [
      {
        question: "Is it safe to book with Nomadroof?",
        answer:
          "Yes, our online platform is safe to book as the rooms, apartments and house are verified. We guarantee that you will move in to the exact place you saw online or we get you a full refund.",
      },
      {
        question: "How do i make a bookig?",
        answer: (
          <>
            <ol className="list-decimal ml-6 text-sm text-gray-600">
              <li>First create an account.</li>
              <li>
                Choose your room or entire apartment/house, and select your
                move-in and move-out dates. You can adjust the filters for
                price, type of property, number of bedrooms or bathroom, and
                amenities.
              </li>
              <li>
                Send us an email or chat with us if you have additional
                questions regarding a listing. Feel free to ask as many
                questions as you have as we will forward your requests and
                questions to Host..
              </li>
              <li>
                Send a booking request by clicking on “Request to Book” once you
                feel you find the property you want to move in..
              </li>
              <li>
                Wait for Host’s confirmation as he/she will have 48 hours to
                accept or reject your booking request..
              </li>
              <li>
                Make the payment of the invoice you will receive once your
                booking request is accepted..
              </li>
              <li>
                Receive a confirmation email of your booking been accepted.
                You”ll also be given the host’s contact details to discuss
                further details directly with him/her..
              </li>
            </ol>
          </>
        ),
      },
      {
        question:
          "How long does it takes to get a respond from my booking request?",
        answer:
          "We contact the landlord as soon as we receive your reservation but the landlord has 48 business hours to respond to your request. Once a decision is made, you will receive an email immediately.",
      },
      {
        question: "What happens when the host accepts my bookings request?",
        answer:
          "Once the host accepts your booking request, you will be sent an invoice. Go to your Dashboard and click on “My Reservations”. You will be able to see the Invoice on the property listing. Click on the green tab “Invoice Created-Check & Pay” to see the details, and make the payment to secure your place.",
      },
      {
        question: "What happens if my booking request a declined or expires?",
        answer: (
          <>
            <p>
              We want your first choice booking request to get accepted, but
              unfortunately it doesn’t always work out.
            </p>
            <br />
            <ul className="list-disc ml-6 text-sm text-gray-600">
              <li>
                If a landlord declines your booking request, we will send you an
                email right away.
              </li>
              <li>
                If your booking request expires, because Landlord has not
                replied to your request within the 48 hours period, then your
                booking request gets cancel.Either way, we have many other
                amazing properties’ listings you can check out. We recommend you
                to message as many Landlords as you need so you end up getting
                the right place to move in..
              </li>
            </ul>
          </>
        ),
      },
      {
        question: "What are the payment methods?",
        answer: (
          <>
            <p>Our payment methods are:</p>
            <br />
            <ul className="list-disc ml-6 text-sm text-gray-600">
              <li>Paypal..</li>
              <li>Debit or credit card.</li>
            </ul>
          </>
        ),
      },
      {
        question: "What am i paying once my booking request is accepted?",
        answer:
          "You are paying the first month’s rent for Host and our booking service fee which is a percentage (15%-23%) of the first month’s rent. We will transfer your first month’s rent to Host, 24 business hours after you move in. Afterwards, you will have to pay the monthly rent and any other payment directly to Host.",
      },
      {
        question: "What is the service fee?",
        answer:
          "The service fee is a percentage amount of the first month’s rent that we charge in order to keep our platform operational and secure, and provide you with an excellent customer service.The service fee percentage varies depending on the city you are moving in to and it ranges from 15% to 23%. You can see the amount of the service fee when you select your staying dates in a property listing.",
      },
      {
        question: "What is the tenant paying me through Nomadroof?",
        answer:
          "Tenant will be paying the first month’s rent. We will hold this amount and will transfer it to you (total amount – host service fee) 24 hours after move-in date, if everything is accordingly.",
      },
      {
        question: "is is safe to make a payment in Nomadroof's Platform?",
        answer:
          "Making a payment in our platform is completely safe as it has a secure encryted payment system. We hold the transfer of your first month’s rent to Host and we only disburse it 48 hours after you move in so you have time to let us now if everything is fine. If Host cancels the booking, you will get your money back.",
      },
      {
        question: "What happens if i need to change the dates of my bookings?",
        answer:
          "Please send us an email to customersupport@nomadroof.com.We do not guarantee that Host will accept your new dates. If Host declines the new dates, your booking is cancelled and it might incur a penanty fee depending on the date it was cancelled and the reasons. Please see cancellation policies.",
      },
      {
        question: "What is the currency you use?",
        answer:
          "The price of property listings  set up in US Dollars. In most banks (and Paypal) you have the option to pay in a different currency. In this case you would be able to pay the exact amount needed and your bank would charge you the corresponding amount in your currency.The remaining renting months and extra payments that you discussed with Landlord are paid outside of the platform.So you should agree on the currency you will use and how they will be paid.",
      },
      {
        question:
          "What is the security deposit? Do i have to pay it in Nomadroof's Platform?",
        answer:
          "The security deposit is the amount you have to pay when you move in and it serves to cover any potential damages that may occur during your stay. Landlord may also keep the security deposit if you leave earlier. If no damages occur, and you leave on the agreed move-out date, the deposit should be refunded. The security deposit amount you see in the listing is used for information purposes and it is not included in the payments you make through Nomadroof’s platform. You will have to pay the security deposit directly  to Landlord in the way you both agreed on.",
      },
    ],
  },
  {
    title: "MOVING IN",
    items: [
      {
        question:
          "What is i move in , but the property is not likr the details of the listing?",
        answer:
          "You should contact our Customer Service team immediately via customersupport@nomadfoof.com,Take detailed photos to show the discrepancy between the listing and the property itself.If a verified property doesn’t match the description or you’re unable to move in, you may be eligible for a refund. Please refer to our Terms & Conditions.",
      },
      {
        question: "What is the Tenant's 24 hours check period?",
        answer:
          "Once you have moved in, you will have 24 hours period to check the property for major defects (e.g. water leaks, infestation, mold). If a property is rundown and unlivable, you would be fully refunded.  Also, if the property differs completely from what you saw in our platform, you might be elegible for a full refund too. For more information, please refer to our Refund Policy.If you have an issue or complaint please let us know! We are here to help you.",
      },
      {
        question: "How do i set Up the rental agreement?",
        answer:
          "Once the host accepts your booking request and you made the payment, you should arrange the signing of the rental agreement that was displayed in the listing by Host. We do not handle any type of contracts.",
      },
      {
        question:
          "I paid the first month's rent through Nomadroof, but what about the remaining months, security deposit and other fees?",
        answer:
          "After the first month’s payment is made through Nomadroof, you will pay the remaining months,security deposit and other applicable fees directly to Host. Both should agree on how these payments will be processed. We will share their contact information to both parties, so you can arrange on this matter.",
      },
    ],
  },
];
const Payment = [
  {
    title: "REFUNDS AND CANCELLATIONS",
    items: [
      {
        question: "What are the cancellation policies?",
        answer: (
          <>
            <ul className="list-disc ml-6 text-sm text-gray-600">
              <li>
                We will refund 100% of your payment (first month + service fee)
                if the host cancels or changes your booking request
                confirmation.
              </li>
              <li>
                We do not provide any cancellation options for the service fee
                once a booking request is confirmed and you make the payment
                (first month + service fee) via our platform unless stated
                otherwise in Terms and Conditions. Whether tenant decides not to
                take the accommodation or shows up, he or she will not be
                entitle for a refund of both the first month rent- which will be
                transfer to landlord for compensation for the empty
                property/room lost- and the service fee- which will be used as
                compensation for our services.
              </li>
            </ul>
            <br />
            <p className="font-semibold">First Month’s Rent</p>
            <ul className="list-disc ml-6 text-sm text-gray-600">
              <li>
                Less than 30 days prior the check-in date, Nomadroof will not
                refund the first month’s rent amount already captured after the
                booking confirmation. Thus, the Tenant will lose the first
                month’s rent and the Booking fee.
              </li>
              <li>
                Between 30 days and 60 days before the check-in date, Nomadroof
                will refund 50% of the first month’s rent to the Tenant..
              </li>
              <li>
                More than 60 days before the check-in date, Nomadroof will
                refund the 100% of the first month’s rent to the tenant.
              </li>
            </ul>
          </>
        ),
      },
      {
        question: "can i cancel the booking?",
        answer:
          "If you haven’t pay the invoice for booking a listing, you can cancel it without incurring any fee.If the landlord has already confirmed your booking and you have paid the invoice, then the amount refunded depends on the time you cancel before your move in date. Please refer to our Terms and Conditions for detailed information.",
      },
      {
        question:
          "I want to terminate the lease agreement with host before the end of the lease . Can Ido it?",
        answer:
          "You can terminate the lease agreement-as you would any lease agreement-before your move out date, but you should discuss that matter directly with Host as Nomadroof does not handle any lease agreements since we are not a contractual party in that stage. If you will pay or not a fee for leaving earlier, depends on the lease terms you had agree with Host previously.",
      },
      {
        question: "i don't like the propertyanymore. What should i do?",
        answer:
          "We advise you to only book and pay for a property you like after you have carefully read the description and rules of the listing.  Please refer to Terms & Conditions for more information.",
      },
      {
        question: "How long does it take to receive a refund?",
        answer:
          "If you have made a Paypal authorization it depends on Paypal, your bank and your region. For example, for some countries this means the money is unblocked within 48 hours, for others it can take as long as 10 days.If you made a payment with your credit card, the payment will be shown in your statement at the end of the month.",
      },
    ],
  },
  {
    title: "REVIEWS AND HELP",
    items: [
      {
        question: "Can I review a Property?",
        answer:
          "Yes, you will be able to review the property and your stay once you move out. Go to “My Reservations” in your Dashboard and click on the green tab Post Review to write your comments and select the rating stars.",
      },
      {
        question: "Do You need more help?",
        answer: (
          <>
            <p>
              If you have more questions or need help, please contact us at:
            </p>
            <br />
            <ul className="list-disc ml-6 text-sm text-gray-600">
              <li>Email: customersupport@nomadroof.com</li>
            </ul>
          </>
        ),
      },
    ],
  },
];

const Faqtenats = () => {
  return (
    <div>
      <hr className="border-orange-500 my-8" />
      <div className=" mb-8">
        <h1 className="text-3xl mb-2">INFORMATION FOR TENANTS</h1>
        <p className="text-sm mb-8">
          Here you will find a collection of information. Contact us if you have
          more questions.
        </p>
        <hr className="border-orange-500 mb-8" />

        <div className="flex flex-col md:flex-row md:space-x-10">
          <FaqSection
            title="Starting with Nomadroof"
            items={startingWithNomadroof}
          />
          <FaqSection
            title="About My Property's Listings"
            items={aboutListings}
          />
        </div>
        <hr className="border-orange-500 mb-8 " />
        <div className="flex flex-col md:flex-row md:space-x-10">
          {faqData?.map((section, index) => (
            <FaqSection
              key={index}
              title={section.title}
              items={section.items}
            />
          ))}
        </div>
        <hr className="border-orange-500 mb-8" />
        <div className="flex flex-col md:flex-row md:space-x-10">
          {Payment?.map((section, index) => (
            <FaqSection
              key={index}
              title={section.title}
              items={section.items}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Faqtenats;
